/* eslint-disable max-len */
import Czech_svg from '@assets/svg/country-flags/Czech.svg';
import ca_french_svg from '@assets/svg/country-flags/french.svg';
import swiss_german_svg from '@assets/svg/country-flags/Swiss-german.svg';
import hungarian_svg from '@assets/svg/country-flags/Hungarian.svg';
import poland_svg from '@assets/svg/country-flags/poland.svg';
import us_svg from '@assets/svg/country-flags/us_flag.svg';
import slovenian_svg from '@assets/svg/country-flags/Slovenian.svg';
import sweden_png from '@assets/svg/country-flags/sweden.png';
import denmark_png from '@assets/svg/country-flags/denmark.png';
import norway_png from '@assets/svg/country-flags/norway.png';
import finland_png from '@assets/svg/country-flags/finland.png';
import uk_svg from '@assets/svg/country-flags/uk_flag.svg';

export const supportedLanguageCodes = [
    'en-us',
    'en-gb',
    'en-ie',
    'fr-ca',
    'en-ca',
    'cs-cz',
    'en-cz',
    'en-ch',
    'de-ch',
    'hu-hu',
    'en-hu',
    'pl-pl',
    'en-pl',
    'sl-si',
    'en-si',
    'sv-se',
    'en-se',
    'da-dk',
    'en-dk',
    'nn-no',
    'en-no',
    'fi-fi',
    'en-fi'
];

export const supportedCountryCodes = ['US', 'CA', 'GB', 'IE', 'CZ', 'CH', 'HU', 'PL', 'SI', 'SE', 'DK', 'NO', 'FI'];

export const languages_available = [
    {
        language: 'US - English',
        image: us_svg,
        code: 'en-us',
        country: 'US'
    },
    {
        language: 'Poland - Polish',
        image: poland_svg,
        code: 'pl-pl',
        country: 'PL'
    },
    {
        language: 'Poland - English',
        image: uk_svg,
        code: 'en-pl',
        country: 'PL'
    },
    {
        language: 'Czech - Czech',
        image: Czech_svg,
        code: 'cs-cz',
        country: 'CZ'
    },
    {
        language: 'Czech - English',
        image: uk_svg,
        code: 'en-cz',
        country: 'CZ'
    },
    {
        language: 'Hungary - Hungarian',
        image: hungarian_svg,
        code: 'hu-hu',
        country: 'HU'
    },
    {
        language: 'Hungary - English',
        image: uk_svg,
        code: 'en-hu',
        country: 'HU'
    },
    {
        language: 'Switzerland - German',
        image: swiss_german_svg,
        code: 'de-ch',
        country: 'CH'
    },
    {
        language: 'Switzerland - English',
        image: uk_svg,
        code: 'en-ch',
        country: 'CH'
    },
    {
        language: 'Canada - French',
        image: ca_french_svg,
        code: 'fr-ca',
        country: 'CA'
    },
    {
        language: 'Canada - English',
        image: us_svg,
        code: 'en-ca',
        country: 'CA'
    },
    {
        language: 'GB - English',
        image: uk_svg,
        code: 'en-gb',
        country: 'GB'
    },
    {
        language: 'IE - English',
        image: uk_svg,
        code: 'en-ie',
        country: 'IE'
    },
    {
        language: 'Slovenia - Slovenian',
        image: slovenian_svg,
        code: 'sl-si',
        country: 'SI'
    },
    {
        language: 'Slovenia - English',
        image: uk_svg,
        code: 'en-si',
        country: 'SI'
    },
    {
        language: 'Sweden - Swedish',
        image: sweden_png,
        code: 'sv-se',
        country: 'SE'
    },
    {
        language: 'Sweden - English',
        image: uk_svg,
        code: 'en-se',
        country: 'SE'
    },
    {
        language: 'Denmark - Danish',
        image: denmark_png,
        code: 'da-dk',
        country: 'DK'
    },
    {
        language: 'Denmark - English',
        image: uk_svg,
        code: 'en-dk',
        country: 'DK'
    },
    {
        language: 'Norway - Norwegian',
        image: norway_png,
        code: 'nn-no',
        country: 'NO'
    },
    {
        language: 'Norway - English',
        image: uk_svg,
        code: 'en-no',
        country: 'NO'
    },
    {
        language: 'Finland - Finnish',
        image: finland_png,
        code: 'fi-fi',
        country: 'FI'
    },
    {
        language: 'Finland - English',
        image: uk_svg,
        code: 'en-fi',
        country: 'FI'
    }
];

export const languageCodeAndCountryMap = {
    'pl-pl': 'pl',
    'en-pl': 'en',
    'cs-cz': 'cs',
    'en-cz': 'en',
    'en-ch': 'en',
    'de-ch': 'de',
    'hu-hu': 'hu',
    'en-hu': 'en',
    'en-us': 'en',
    'en-gb': 'en',
    'en-ie': 'en',
    'fr-ca': 'fr',
    'en-ca': 'en',
    'sl-si': 'sl',
    'en-si': 'en',
    'sv-se': 'sv',
    'en-se': 'en',
    'da-dk': 'da',
    'en-dk': 'en',
    'nn-no': 'nn',
    'en-no': 'en',
    'fi-fi': 'fi',
    'en-fi': 'en'
};

export const browser_lang_code_map = {
    'pl': 'pl-pl',
    'cs': 'cs-cz',
    'de': 'de-ch',
    'hu': 'hu-hu',
    'en': 'en-us',
    'fr': 'fr-ca',
    'sl': 'sl-si',
    'sv': 'sv-se',
    'da': 'da-dk',
    'nn': 'nn-no',
    'fi': 'fi-fi',
}

export const getSupportedLanguageCode = (lang: string): string => lang && supportedLanguageCodes.includes(lang) ? lang : 'en-us';

export const getSupportedCountryCode = (code: string): string => code && supportedCountryCodes.includes(code.toUpperCase()) ? code.toUpperCase() : 'US';

export const getLanguageCode = (): string => {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const language_code = urlParams.get('lang'); // check Magento is sending language preference
    const language = localStorage.getItem('language'); // check localStorage has language preference is set
    const browserLocaleLang = window.navigator.language.toLocaleLowerCase(); // get browser default language
    const browserDefaultLang = browserLocaleLang.length === 2 ? browser_lang_code_map[browserLocaleLang]:browserLocaleLang;
    const four_char_lang_code = language_code || language || browserDefaultLang || 'en-us';
    const language_preference = getSupportedLanguageCode(four_char_lang_code);
    return language_preference;
};

export const getLanguageCountryCode = (): string => {
    const languagePreference = getLanguageCode();
    const countryCode = languagePreference.split('-')[1];
    const languageCountryCode = supportedCountryCodes.includes(countryCode.toUpperCase()) ? countryCode.toUpperCase() : 'US';
    return languageCountryCode;
};

export const languageCode_okta = {
    'pl-pl': 'pl',
    'en-pl': 'en',
    'cs-cz': 'cs',
    'en-cz': 'en',
    'en-ch': 'en',
    'de-ch': 'de',
    'hu-hu': 'hu',
    'en-hu': 'en',
    'en-us': 'en',
    'en-gb': 'en',
    'en-ie': 'en',
    'fr-ca': 'fr',
    'en-ca': 'en',
    'sl-si': 'sl',
    'en-si': 'en',
    'sv-se': 'sv',
    'en-se': 'en',
    'da-dk': 'da',
    'en-dk': 'en',
    'nn-no': 'nn',
    'en-no': 'en',
    'fi-fi': 'fi',
    'en-fi': 'en'
};
